import i18n from 'i18next';

import {apiClient} from 'core/apiClient';
import {
    AuthDataRaw,
    ParticipantRegistrationRequest,
    DirectorRegistrationRequest,
    EmployeeRegistrationRequest,
    EmployeeUpdateRequest,
    ParticipantUpdateRequest,
} from 'types';
import {Participant} from 'types/participants';
import {CertData, CryptoProCert} from 'types/plugins/cadesPlugin';

import {parseAuthData} from './mappers/auth';

const REGISTER_URL = 'uaa/web';
const PARTICIPANT_URL = 'uaa/clients';
const USER_URL = 'uaa/users';
const LANGUAGE_HEADERS_PRESET = () => ({headers: {'Accept-Language': i18n.language}});

export async function registration(payload: any) {
    const path = `${REGISTER_URL}/register`;
    const response = (await apiClient.post<AuthDataRaw>(path, payload, LANGUAGE_HEADERS_PRESET()))
        .data;
    const parsedAuthData = parseAuthData(response);
    return [parsedAuthData, payload.saveCredentials];
}

export async function getExtendedCert(cert: CryptoProCert | null) {
    if (!cert) throw new Error('Certificate not found');
    return apiClient.post<CertData>(`${REGISTER_URL}/eds/validate-and-parse`, cert);
}

export async function createUser(payload: EmployeeRegistrationRequest) {
    const path = `${REGISTER_URL}/register`;
    return apiClient.post<number>(path, payload, LANGUAGE_HEADERS_PRESET());
}

export async function updateUser(payload: EmployeeUpdateRequest & {id: string | number}) {
    const {id: userId, ...body} = payload;
    return apiClient.put(USER_URL, body, {params: {userId}});
}

export async function removeUser(userId: string | number) {
    return apiClient.delete(`${USER_URL}/${userId}`);
}

export async function boundUserWithParticipant(params: {
    clientId?: string | number | null;
    userId: string | number;
}) {
    const {userId, clientId} = params;
    return (
        await apiClient.put<Participant[]>(`${USER_URL}/${userId}/client`, null, {
            params: {clientId},
        })
    ).data;
}

export async function createOrganization(payload: DirectorRegistrationRequest) {
    const path = `${REGISTER_URL}/register`;
    return apiClient.post(path, payload, LANGUAGE_HEADERS_PRESET());
}

export async function createParticipant(payload: ParticipantRegistrationRequest) {
    return apiClient.post(PARTICIPANT_URL, payload);
}

export async function updateParticipant(payload: ParticipantUpdateRequest & {id: string | number}) {
    const {id, ...body} = payload;
    return (
        await apiClient.put<Participant[]>(PARTICIPANT_URL, body, {
            params: {clientId: id},
        })
    ).data;
}

export async function removeParticipant(clientId: string | number) {
    return apiClient.delete(`${PARTICIPANT_URL}/${clientId}`);
}
